import "../styles/Footer.css"

function Footer() {
    return (
        <section className="footer-real">
          <div className="footer-text-container-real">
            <div className="devsinc-real">Devsinc</div>
            <div className="company-2022-real">
              Company, 2022 © All Rights Reserved
            </div>
          </div>
        </section>
    );
}
  
  export default Footer;